import tw, { styled } from 'twin.macro';

const ContainerHeader = styled.div`
  ${tw`flex flex-col`}
`;
export default ContainerHeader;
